module.exports = __webpack_public_path__ + "static/media/college_8.05441fbc.jpg";